var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "id": "topbar-post-login",
      "color": "transparent",
      "dark": "",
      "dense": "",
      "fixed": "",
      "prominent": ""
    }
  }, [_c('div', {
    staticClass: "mt-7"
  }, [_c('span', [_vm._v("SECRETARIA DE EDUCAÇÃO E ESPORTES")])]), _c('v-spacer'), _c('v-toolbar-title', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "app-icon",
    attrs: {
      "src": "https://cdn.educacao.pe.gov.br/storage/assets/logo_SEE_psh_G02_B_png_779d0caae9.png",
      "alt": "brasão-home-64px"
    }
  })])])], 1), _c('div', {
    staticClass: "pt-15",
    attrs: {
      "id": "background-image-wrapper"
    }
  }, [_c('v-container', {
    staticClass: "fill-height d-flex align-center justify-center"
  }, [_c('vue-aos', {
    attrs: {
      "animation-class": "animate__zoomInLeft animate__animated"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "80vh"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-10 rounded-lg",
    attrs: {
      "elevation": "10",
      "color": "rgba(255, 255, 255, 0.9)"
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.recuperarSenha.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/img/siglasigfoco.svg",
      "alt": "brasão-home-64px"
    }
  }), _c('h1', {
    staticClass: "subtitle-1 blue--text text--darken-4 mt-4 font-weight-bold"
  }, [_vm._v(" Recuperar Senha ")])])], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    staticClass: "rounded-lg ignore-tab",
    attrs: {
      "solo": "",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v, 'Senha é obrigatória');
      }, function (v) {
        return _vm.$min(v, 8, 'A senha deve conter pelo menos 8 caracteres.');
      }, function (v) {
        return _vm.$max(v, 256, 'A senha deve conter no máximo 256 caracteres..');
      }],
      "placeholder": "Nova Senha*",
      "type": _vm.exibirSenha ? 'text' : 'password',
      "prepend-inner-icon": "mdi-lock",
      "append-icon": "mdi-eye"
    },
    on: {
      "click:append": function ($event) {
        _vm.exibirSenha = !_vm.exibirSenha;
      }
    },
    model: {
      value: _vm.user.senha,
      callback: function ($$v) {
        _vm.$set(_vm.user, "senha", $$v);
      },
      expression: "user.senha"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "solo": "",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v, 'Confirmação de senha é obrigatória');
      }, function (v) {
        return _vm.$min(v, 8, 'Confirmação de senha deve conter pelo menos 8 caracteres.');
      }, function (v) {
        return _vm.$max(v, 256, 'Confirmação de senha deve conter no máximo 256 caracteres.');
      }, function (v) {
        return v === _vm.user.senha || 'As senhas informadas não correspondem.';
      }],
      "type": _vm.exibirConfirmarSenha ? 'text' : 'password',
      "placeholder": "Confirme a Nova Senha*",
      "prepend-inner-icon": "mdi-lock",
      "append-icon": "mdi-eye"
    },
    on: {
      "click:append": function ($event) {
        _vm.exibirConfirmarSenha = !_vm.exibirConfirmarSenha;
      }
    },
    model: {
      value: _vm.user.confirmarSenha,
      callback: function ($$v) {
        _vm.$set(_vm.user, "confirmarSenha", $$v);
      },
      expression: "user.confirmarSenha"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "py-4 px-6 mr-3 rounded-lg",
    attrs: {
      "color": "primary",
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('v-btn', {
    staticClass: "py-4 px-6 mr-3 rounded-lg",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.acessarSistema();
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "50%"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("Confirmação de Alteração de Senha")])]), _c('div', {
    staticClass: "container dialog mt-7"
  }, [_c('v-row', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Senha Recuperada com sucesso!")])]), _c('v-row', [_c('p', [_vm._v("Acesse o sistema de Gestão de Formação Continuada com as credenciais cadastradas.")])])], 1), _c('div', {
    staticClass: "text-center mt-5"
  }, [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.acessarSistema();
      }
    }
  }, [_vm._v("Acessar o Sistema")]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.toggleModal(false);
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }